import { GridSortModel } from "@mui/x-data-grid";
import { useTableState } from "../../../hooks/useTableState";
import { TABLE_NAME } from "../../../utils/constant";
import { bookingColumnDef, orderHeadColumnDef, orderStyleColumnDef } from "../utils/OrdersColumnDef";

export const useResetAllOrdersTableStates = () => {
  const defaultSortStyle: GridSortModel = [{ field: "created_at", sort: "desc" }];
  const defaultSort: GridSortModel = [{ field: "creationDate", sort: "desc" }];
  const defaultColumnOrder = orderHeadColumnDef.map((column) => column.field);
  const defaultColumnStyle = orderStyleColumnDef.map((column) => column.field);
  const defaultColumnBooking = bookingColumnDef.map((column) => column.field);
  const { updateSort: updateSortStyle, clearTableState: clearStyle } = useTableState(TABLE_NAME.orderStyle, [...defaultColumnStyle, "actions"]);
  const { updateSort: updateSortBooking, clearTableState: clearBooking } = useTableState(TABLE_NAME.booking, [...defaultColumnBooking, "actions"]);
  const { updateSort: updateSortOrder, clearTableState: clearOrder } = useTableState(TABLE_NAME.orderSheet, [...defaultColumnOrder, "actions"]);

  const resetTableOrders = () => {
    clearStyle(); 
    updateSortStyle(defaultSortStyle);
    clearBooking(); 
    updateSortBooking(defaultSort);
    clearOrder(); 
    updateSortOrder(defaultSort);
   };

  return { resetTableOrders };
};